<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon">close</mat-icon>
</button>
<h1 mat-dialog-title align="center">Formularios asignados</h1>
<mat-progress-bar *ngIf="formsUser == null" mode="indeterminate">
</mat-progress-bar>
<mat-dialog-content class="create-category">
  <mat-list>
    <mat-list-item *ngFor="let form of formsUser">
      <mat-icon mat-list-icon>assignment</mat-icon>
      <div mat-line>{{form.formulario_nombre}}</div>
    </mat-list-item>
  </mat-list>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button matTooltip="Asignar un nuevo formulario a este usuario" [matMenuTriggerFor]="menuForms"
    cdkFocusInitial>
    <mat-icon>assignment_ind</mat-icon>
    <sup>
      <mat-icon>add</mat-icon>
    </sup>
  </button>
  <mat-menu #menuForms="matMenu">
    <button mat-menu-item *ngFor="let form of formsAdd"
      (click)="selectForm(form.formulario_Id)">{{form.formulario_nombre}}</button>
  </mat-menu>

</mat-dialog-actions>